<template>
    <div>
        <v-row>
            <v-text-field 
                v-model="searchName" 
                placeholder="all" 
                label="Name" 
                outlined 
                dense 
                v-on:keyup.enter="search">
            </v-text-field>
            <v-select
                v-model="searchType"
                :items="types"
                label="Type"
                dense
                outlined
                clearable
            ></v-select>
            <v-select
                v-show="weaponSearch"
                v-model="searchWeaponType"
                :items="weaponTypes"
                label="Weapon Type"
                dense
                outlined
                clearable
            ></v-select>
            <v-select
                v-show="weaponSearch"
                v-model="searchWeaponRange"
                :items="weaponRanges"
                label="Weapon Range"
                dense
                outlined
                clearable
            ></v-select>
            <v-select
                v-show="armorSearch"
                v-model="searchArmorType"
                :items="armorTypes"
                label="Armor Type"
                dense
                outlined
                clearable
            ></v-select>

            <v-btn v-on:click="search">Search</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-on:click="collapseAll">Collapse All</v-btn>
        </v-row>
        <v-row>
            
        </v-row>

        <v-data-table
            :headers="equipmentHeaders"
            :items="equipmentArray"
            :expanded.sync="expanded"
            item-key="name"
            show-expand
            class="elevation-1"

            :items-per-page="-1"
            hide-default-footer

        >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.cost.quantity="{ item }" >
                <span>{{item.cost.quantity + " " + item.cost.unit}}</span>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <div class="item-contents">
                        <v-row v-if="hasDescription(item)">
                            <v-col>
                                <span class="detail-header">Description</span>
                                <br>
                                {{descriptionString(item)}}
                            </v-col>
                        </v-row>
                    
                        <v-row v-if="isWeapon(item)">
                            <v-col>
                                <div>
                                    <span class="detail-header">Damage: </span> {{damage(item)}}  {{damageType(item)}}
                                </div>

                                <div>
                                    <span class="detail-header">Range: </span> {{range(item)}}<br>
                                    <span class="detail-header">Long Range: </span> {{longRange(item)}}
                                </div>

                                <div v-if="isThrown(item)">
                                    <span class="detail-header">Throw Range: </span> {{throwRange(item)}}<br>
                                    <span class="detail-header">Long Throw Range: </span> {{throwRangeLong(item)}}
                                </div>
                            </v-col>
                        </v-row>

                        <v-row v-if="!isWeapon(item)">
                            <v-col>
                                <div v-show="isArmor(item)">
                                    <span class="detail-header">AC: </span> {{armorClass(item)}}<br>
                                    <span class="detail-header">Type: </span> {{armorType(item)}}
                                </div>

                                <div v-show="isGear(item)">
                                    <span class="detail-header">Type: </span> {{gearType(item)}}
                                </div>

                                <div v-show="isTool(item)">
                                    <span class="detail-header">Type: </span> {{toolType(item)}}
                                </div>

                                <div v-show="isMount(item)">
                                    <span class="detail-header">Type: </span> {{vehicleType(item)}}
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </td>
            </template>
        </v-data-table>
    </div>
</template>


<script>
export default {
    props:["equipment"],

    data () {
        return {
            searchName: "",
            searchType: "",
            searchWeaponType: "",
            searchWeaponRange: "",
            searchArmorType: "",

            expanded: [],
            singleExpand: false,
            equipmentHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Type', value: 'equipment_category.name' },
                { text: 'Weight', value: 'weight' },
                { 
                    text: 'Cost', 
                    value: 'cost.quantity', 
                    sortable: false, 
                },
            ],
            equipmentArray: [],

            types: [
                "weapon",
                "armor",
                "adventuring gear",
                "tools",
                "mounts and vehicles"
            ],

            weaponTypes: [
                "simple",
                "martial"
            ],

            weaponRanges: [
                "melee",
                "ranged"
            ],

            armorTypes: [
                "light",
                "medium",
                "heavy"
            ]
        }
    },

    methods: {
        hasDescription(item) {
            return item.desc !== undefined;
        },
        descriptionString(item) {
            if(this.hasDescription(item))
            {
                let descString = "";
                item.desc.forEach(element => {
                    descString += element + "\n"
                });
                return descString;
            }
        },
        collapseAll() {
            this.expanded = [];
        },

        search() {
            this.equipmentArray = this.equipment.filter(this.searchFilter);
        },

        searchFilter(equipment) {
            let isResult = true;
            if(this.searchName.length > 0 && isResult)
            {
              isResult = equipment.name.toLowerCase().includes(this.searchName.toLowerCase());
            }
            if(this.searchType.length > 0 && isResult)
            {
              isResult = equipment.equipment_category.name.toLowerCase() == this.searchType.toLowerCase();
            }
            if(this.searchWeaponType.length > 0 && isResult)
            {
              isResult = equipment.weapon_category.toLowerCase() == this.searchWeaponType.toLowerCase();
            }
            if(this.searchWeaponRange.length > 0 && isResult)
            {
              isResult = equipment.weapon_range.toLowerCase() == this.searchWeaponRange.toLowerCase();
            }
            if(this.searchArmorType.length > 0 && isResult)
            {
              isResult = equipment.armor_category.toLowerCase() == this.searchArmorType.toLowerCase();
            }
            return isResult;
        },

        isWeapon(item) {
            return (item.equipment_category.name.toLowerCase() === "weapon");
        },
        isArmor(item) {
            return (item.equipment_category.name.toLowerCase() === "armor");
        },
        isGear(item) {
            return (item.gear_category !== undefined);
        },
        isMount(item) {
            return (item.equipment_category.name.toLowerCase() === "mounts and vehicles");
        },
        isTool(item) {
             return (item.equipment_category.name.toLowerCase() === "tools");
        },
        isThrown(item) {
            return (item.throw_range !== undefined)
        },
        hasContents(item) {
            return (item.contents !== undefined)
        },
        damage(item) {
            if(this.isWeapon(item) && item.damage !== undefined)
            {
                return item.damage.damage_dice;
            }
            return "";
        },
        damageType(item) {
            if(this.isWeapon(item) && item.damage !== undefined)
            {
                return item.damage.damage_type.name;
            }
            return "";
        },
        armorClass(item) {
            if(this.isArmor(item))
            {
                return item.armor_class.base;
            }
            return "";
        },
        armorType(item) {
            if(this.isArmor(item))
            {
                return item.armor_category;
            }
            return "";
        },
        gearType(item) {
            if(this.isGear(item))
            {
                return item.gear_category.name;
            }
            return "";
        },
        range(item) {
            if(this.isWeapon(item))
            {
                return item.range.normal;
            }
            return "";
        },
        longRange(item) {
            if(this.isWeapon(item))
            {
                if(item.range.long !== null)
                {
                    return item.range.long;
                }
                return "N/A";
            }
            return "";
        },
        toolType(item) {
            if(this.isTool(item))
            {
                return item.tool_category;
            }
            return "";
        },
        vehicleType(item) {
            if(this.isMount(item))
            {
                return item.vehicle_category;
            }
            return "";
        },
        throwRange(item) {
            if(this.isThrown(item))
            {
                return item.throw_range.normal;
            }
            return "";
        },
        throwRangeLong(item) {
            if(this.isThrown(item))
            {
                return item.throw_range.long;
            }
            return "";
        },
        contents(item) {
            if(this.hasContents(item))
            {
                let contentArray = []
                item.contents.forEach(element => {
                    let contentString = `${element.item.name} (${element.quantity})`;
                    contentArray.push(contentString);
                });
                return contentArray;
            }
            return [];
        }
    },

    computed: {
        weaponSearch() {
            return (this.searchType.toLowerCase()==="weapon");
        },
        armorSearch() {
            return (this.searchType.toLowerCase()==="armor");
        },
    },

    beforeMount() {
        this.equipmentArray = this.equipment;
    },
    watch: {
        searchWeaponType(newVal) {
            if(newVal == null)
            {
                this.searchWeaponType = "";
            }
        },
        searchWeaponRange(newVal) {
            if(newVal == null)
            {
                this.searchWeaponRange = "";
            }
        },
        searchArmorType(newVal) {
            if(newVal == null)
            {
                this.searchArmorType = "";
            }
        },
        searchType(newValue) {
            if(newValue == null)
            {
                this.searchType = "";
            }
            if(newValue == null || newValue.toLowerCase() !== "armor") {
                this.searchArmorType = "";
            }
            if(newValue == null || newValue.toLowerCase() !== "weapon") {
                this.searchWeaponType = "";
                this.searchWeaponRange = "";
            }
        },
    }
    
}
</script>

<style scoped>
.v-text-field, .v-btn, .v-select, .v-checkbox {
    margin: 10px !important;
    max-width: 200px !important;
}
.item-contents {
    margin: 15px !important;
}
.spell-type-area {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
}
.detail-header {
    font-weight: bold;
}

</style>
